import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { GiftCardService } from './gift-card.service';
import { GiftCardComponent } from './gift-card.component';
import { ngxLoadingAnimationTypes, NgxLoadingModule} from 'ngx-loading';
import { AuthGuard } from '../_guards/auth.guard';
import { EnvironmentSpecificResolver } from '../environs/services/environment-specific-resolver.service';



@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    JsonpModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '', component: GiftCardComponent, resolve: { envSpecific: EnvironmentSpecificResolver }
      }
    ]),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.6)',
      backdropBorderRadius: '4px',
      primaryColour: '#ffffff',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff'
    })
  ],
  providers: [GiftCardService],
  declarations: [GiftCardComponent]
})
export class GiftCardModule { }
